module.exports = __webpack_public_path__ + "static/media/image-placeholder.e66ad13e.jpg";